
export const TIME_FORMAT: string = "YYYY-MM-DDTHH:mm";
